import * as React from "react";
import "../Styles/style.css";

export default function PrivacyPolicy() {
  return (
    <>
      <div className="infoMainConatiner py-5">
        <div className="container">
          <h4 className="termsMainHeading">Privacy Policy</h4>

          <div className="infoMainBody p-3">
            <p>
            We   are   pleased   to   make   available   to   you   the   essential   data   management
guidelines, plus the relevant rights you are entitled to in the framework of our user
privacy guidelines.
              <br /> <br />
              Privacy protection of the user data is the cornerstone of FameWheels, we collect
data through our online platform, including our website and mobile app. This rule of
data collection is amended/added to this declaration by publishing them at this URL
and they will come into effect from the time of their publication. Valuing the privacy
of our clients is the core value of our company and due to this we always strive to
keep your information safe.
              <br /> <br />
              The significant purpose of this policy is to make you aware of how we treat personal
information, and your privacy rights and to demonstrate the legal safeguards that
are in effect.
              <br /> <br />
              Through the use of this website and this mobile application, irrespective of whether
we   have   published   any   changes   or   updates,   you   are   thereby   indicating   your
acceptance of these updates. We implore you to spare some time and to go through
this privacy statement carefully before you make use of our Services.
<br /><br />This User Policy is effective from 1st December 2020.

            </p>
            <br />
            <h5>Extent and Revisions of This User Privacy:</h5>
            <p>
            This privacy statement is validated to your engagement at this platform, utilising
FameWheels   website,   applications,   services,   products,   and   utilities   (hereinafter
called 'Services'). This inclusiveness in part is related to mobility, when it is ensured
through mobile phones and applications.
            </p>
            <br />
            <h5>Data Controller:</h5>
            <p>
            FameWheel anticipates the right to collect and process your information to provide
the  best  services.  contingent  upon  how  you  employ  these  Services.  FameWheels
complete address is as follows:
              <br /> <br />
              Fame Wheels (Pvt) Limited,
              <br /> 214, The Plaza, Clifton Block 9, <br />
              Karachi, Pakistan.
            </p>
            <br />
            <h5>Types of Personal Data We Collect and Process:</h5>
            <p>
            The information that is disseminated by FameWheels is meant to help and benefit
people in general. This is to provide you with our services we may record, store and
utilize   your   personal   data   which   consist   of   but   not   limited   to   the   following
information such as your account identification, name, gender, age, email address,
contact number, address or other vital information. Additionally, we might gather
some non-personal data regarding you with the help of different tools, for instance
tracking your movements by IP address, mobile device ID, and others. This should
be mentioned that we usually get personally identifiable information on you only
when you freely give those details—those can be the participation in a survey or the
registration   form   completion.   The   types   of   data   that   could   be   requested   include
your full name and email address, as well as other information.
              <br /> <br />
              Your   voluntary   self-submission   of   personal   information   constitutes   your
acknowledgement and the agreement to the transfer of data and its storage on our
servers.
            </p>
            <br />
            <h5>Non-Personal Information We Gather:</h5>
            <p>
              <b>Usage Details:</b> This   includes   your   agreement   on   the   corresponding   terms   for
utilizing our platform, which involve the services you use, the content you search for
or interact with, the functions you engage with, the actions you initiate, and other
parameters such as the duration, timing, and your frequency of engagement.
              <br /> <br />
              <b>Device Insights:</b>  this incorporates the personal data or the electronic devices you
utilise   to   access   our   platform,   including   internet-enabled   devices   such   as
computers, mobile phones, laptops, tablets, and others ('Devices'). It would most
probably   be   indicative   regarding   the   whereabouts   of   your   gadget,   as   per   your
choices,   and   details   like   internet   connectivity,   IP   address,   OS   and   platforms,
preferential browsing, device type, device character, network information, metadata
and other relevant files on your Device as well. Moreover, there is data about the
website you just visited and the history of your browsing on websites.
              <br />
              It   is   worth   noting   that   the   obtained   information   is   not   individually   identifiable,
indicating   that   the   data   are   collected   to   optimize   consumer   behaviour   and   best
understanding and preferences, hence leading to the creation of a more customer-
oriented approach.
            </p>
            <br />
            <h5>Utilization of Collected Information:</h5>
            <p>
            FameWheel  collects   information   through   online  platforms   to   furnish   you   with   our
products and services, incorporated with the functional and operational services of
our platform.
              <br /> <br />
              <b>Informative Communication:</b> To acquaint you with the multitude of products and
services on offer on our platform which is ever ready to attend to your issues.
              <br />
              <b>Customer Queries:</b> To address the queries and problems on products or services
you are searching for.
              <br />
              <b>Surveys and Marketing Initiatives:</b> To deliver surveys and promo materials or to
make   presentations   of   programs   and   campaigns   designed   by   us   that   are   either
directly or indirectly relevant to you. <br />
              <b>Enhanced Platform Usage:</b>  To   optimize   platform   usage,   personalize   content
based on preferences, improve products or services, process transactions, and offer
special offers.
<br />
<b>Performance evaluation:</b>  Help to find technical faults and conduct data analysis
to provide user-friendly and satisfactory service.
<br />
              {/* <b>Platform Enhancement:</b> For assessing platform performance,
              identifying technical glitches, and conducting data analysis to
              elevate your user experience.
              <br /> */}
              <b>Platform Integrity:</b> The goal is to maintain the platform's authenticity and keep it
safe.
              <br />
              <b>Policy Updates:</b> To notify you about any amendments made to the Privacy Policy
or Terms of Use on any FameWheels platform.
              <br />
              <b>Security Measures:</b> Practitioners of information security respond to the necessities
related to platform security, data breaches, detecting glitches, and responding to
security risks or investigating illicit activities or potential fraud.
              <br />
              <b>Knowledge Enhancement:</b> To   share   valuable   data,   information,   updates,
announcements, and educational content related to our platform that will enhance
your knowledge related to your interest.
              <br />
              <b>Contractual Commitments:</b>  To   fulfil   the   law   enforcement   rights   contracted
between both you and us.
              <br />
              <b>Interactive Participation:</b>  To   enable   you   to   perform   interactive   engagements
through our Platform.
              <br />
              <b>Tailored Communications:</b> To   communicate   to   you   about   our   products,   and
services as well as those of our third-party pairing that might be apt for you.
              <br />
              <b>Aggregate Insights:</b> To attract people who are willing to commit to contributing
their   data   while   also   guaranteeing   the   anonymity   of   the   gathered   aggregated
insights and statistics.
              <br />
              <b>Personalized Advertisements:</b> Precisely   for   showing   you   the   ads   that   are
targeted on your interests.
              <br />
              <b>Advertiser Insights:</b> Our platform assists advertisers and partners in analysing the
success   of   their   ad   campaigns   and   services   as   well   as   comprehension   of   user
behaviour.
              <br />
              <b>Diagnostic Measures:</b> To troubleshoot server problems, execute web and mobile
apps, and run smooth service I am responsible.
              <br />
              <b>Explicit Consent:</b> Your information may be additionally used on the sites we own
and operate, or any partners mentioned in the privacy policy.
              <br />
              <b>Other Consensual Uses:</b>  Unless   for  any  special  purposes   for  other  purposes   in
which the consent of the data subject is sought and obtained.
              <br />
              <b>Opting Out of Future Communications:</b> For users, there is a choice on the table
of declining further notifications from us and other companies. The process for de-
underlined is outlined in the underlined. In case you want to quit communicating
with us in such way, please do follow the instructions provided.
            </p>
            <br />
            <h5>User Violations:</h5>
            <p>
            You give consent for termination or suspension of membership on the platform in
case some of your items, ads, posts, comments or any extra information on the site
are   found   in   violation   of   any   provision   in   this   agreement   or   our   listing   policy.
Furthermore, the right of the site to refuse you or any individual who represents you
access to the Site is reserved too.
            </p>
            <br />
          </div>
        </div>
      </div>
    </>
  );
}
